/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IAdmission } from 'app/shared/model/admission.model';
import { IEspecialty } from 'app/shared/model/especialty.model';

export interface IAdmissionConsultant {
  id?: string;
  primary?: boolean;
  billable?: boolean;
  assignedOn?: number | null;
  ReleasedOn?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  consultant?: IDoctor | null;
  admission?: IAdmission;
  specialty?: IEspecialty | null;
}

export const defaultValue: Readonly<IAdmissionConsultant> = {
  primary: false,
  billable: false,
  active: false,
};
